import { put } from "redux-saga/effects";
import { API } from 'aws-amplify';
import { getResponseData } from '../../utils/apiHelpers';

import moment from "moment";

import * as actions from "../actions";
import { handleApiError } from '../../utils/apiErrorHandler';

const kryBoodskappe = async () => {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/boodskappe`;
        const response = await API.get(apiName, path, { response: true });
        // console.log(response);
        return getResponseData(response, []);
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        throw errordata;
    }
}

const merkBoodskapGelees = async (id) => {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/boodskappe?id=${encodeURIComponent(id)}`;
        let myInit = {
            response: true,
            body: moment.utc(),
        };
        const response = await API.put(apiName, path, myInit);
        // console.log(response);
        return response.data;
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        throw errordata;
    }
}

export function* getNotificationsSaga() {
    try {
        let boodskappe = yield kryBoodskappe();
        yield put(actions.setNotifications(boodskappe));
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getNotificationsFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

export function* setNotificationGeleesSaga(action) {
    try {
        yield merkBoodskapGelees(action.id);
        // yield put(actions.setNotificationGelees(boodskappe));
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        // yield put(actions.getNotificationsFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}